<template>
  <v-container fluid class="release-page" dir="rtl">
    <v-alert v-if="!isManager" type="warning" outlined>این بخش فقط برای مدیر قابل دسترسی است.</v-alert>
    <template v-else>
      <div class="d-flex align-center justify-space-between mb-6">
        <div><h1 class="text-h5 font-weight-bold">نسخه‌های اپ انبار</h1>
          <p class="text-body-2 grey--text mt-2">تنظیمات / نسخه‌های اپ — آپلود پیش‌نویس و انتشار برای کاربران</p></div>
        <v-btn outlined :loading="loading" :disabled="busy" @click="load">تازه‌سازی</v-btn>
      </div>
      <v-alert v-if="error" type="error" outlined>{{ error }}</v-alert>
      <v-alert v-if="notice" type="success" outlined>{{ notice }}</v-alert>
      <v-row>
        <v-col cols="12" lg="4">
          <v-card outlined class="pa-5">
            <h2 class="text-h6 mb-4">ثبت نسخهٔ جدید</h2>
            <v-form ref="form" @submit.prevent="upload">
              <v-text-field v-model="versionName" label="نام نسخه، مثلاً 1.1.0" outlined dense
                :disabled="busy" :rules="[requiredText]" />
              <v-text-field v-model="versionCode" label="کد نسخه (versionCode داخل APK)" type="number"
                min="1" outlined dense :disabled="busy" :rules="[positiveInteger]"
                hint="باید با فایل APK یکسان و از نسخهٔ قبلی بزرگ‌تر باشد." persistent-hint class="mb-4" />
              <v-file-input v-model="apk" accept=".apk,application/vnd.android.package-archive" label="فایل APK"
                outlined dense show-size :disabled="busy" :rules="[validApk]" />
              <v-textarea v-model="notes" label="تغییرات این نسخه" outlined rows="4" :disabled="busy" />
              <v-switch v-model="required" label="به‌روزرسانی اجباری" :disabled="busy"
                hint="فقط برای نسخه‌هایی که ادامهٔ کار با نسخهٔ قدیمی ممکن نیست." persistent-hint />
              <v-btn type="submit" color="primary" block large class="mt-6" :loading="uploading" :disabled="busy">
                ثبت پیش‌نویس
              </v-btn>
              <p class="text-caption grey--text mt-3">پس از آپلود، برای فعال‌شدن آپدیت باید «انتشار» را بزنید.</p>
            </v-form>
          </v-card>
        </v-col>
        <v-col cols="12" lg="8">
          <v-progress-linear v-if="loading" indeterminate />
          <v-card v-if="!loading && !error && !releases.length" outlined class="pa-8 text-center">
            هنوز نسخه‌ای ثبت نشده است.
          </v-card>
          <v-card v-for="release in releases" :key="release.id" outlined class="pa-5 mb-4">
            <div class="d-flex align-center flex-wrap mb-3" style="gap: 12px">
              <h2 class="text-h6">نسخهٔ {{ release.version_name }}</h2>
              <v-chip small :color="release.published ? 'success' : 'grey'" outlined>
                {{ release.published ? 'منتشرشده' : 'پیش‌نویس / غیرفعال' }}
              </v-chip>
              <v-chip v-if="release.required" small color="warning" outlined>اجباری</v-chip>
            </div>
            <p class="text-body-2 grey--text">کد نسخه: {{ release.version_code }} · حجم: {{ size(release.size) }} · ثبت: {{ date(release.created_at) }}</p>
            <p class="release-notes">{{ release.notes || 'بدون توضیحات' }}</p>
            <div class="d-flex flex-wrap" style="gap: 8px">
              <v-btn color="primary" :outlined="release.published" :disabled="busy"
                @click="confirmation = release">{{ release.published ? 'توقف انتشار' : 'انتشار نسخه' }}</v-btn>
              <v-btn text :href="release.apk" target="_blank" rel="noopener">دریافت APK</v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog :value="!!confirmation" max-width="460" :persistent="busy" @input="!$event && (confirmation = null)">
        <v-card v-if="confirmation" class="pa-5">
          <h2 class="text-h6 mb-3">{{ confirmation.published ? 'توقف انتشار نسخه' : 'انتشار نسخهٔ جدید' }}</h2>
          <p>{{ confirmation.published ? 'این نسخه دیگر به کاربران پیشنهاد نمی‌شود.' : 'نسخهٔ ' + confirmation.version_name + ' برای اپ‌های قدیمی قابل دریافت می‌شود. آیا فایل را بررسی کرده‌اید؟' }}</p>
          <v-card-actions><v-spacer /><v-btn text :disabled="busy" @click="confirmation = null">انصراف</v-btn>
            <v-btn color="primary" :loading="publishing" @click="publish">تأیید</v-btn></v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
export default {
  name: 'AppReleases',
  data: () => ({ releases: [], loading: false, uploading: false, publishing: false,
    error: '', notice: '', versionName: '', versionCode: '', notes: '', apk: null, required: false, confirmation: null }),
  computed: {
    isManager() { return !!(this.user && (this.user.user_type === 'ma' || this.user.is_superuser)); },
    canLoad() { return this.isManager && !!this.token; },
    busy() { return this.uploading || this.publishing; },
  },
  watch: { canLoad: { immediate: true, handler(value) { if (value) this.load(); } } },
  methods: {
    requiredText(value) { return !!String(value || '').trim() || 'این فیلد الزامی است.'; },
    positiveInteger(value) { return (Number.isInteger(Number(value)) && Number(value) > 0) || 'عدد صحیح مثبت وارد کنید.'; },
    validApk(file) { return !!(file && /\.apk$/i.test(file.name) && file.size <= 200 * 1024 * 1024) || 'فایل APK تا ۲۰۰ مگابایت انتخاب کنید.'; },
    size(bytes) { return (bytes / 1024 / 1024).toFixed(1) + ' مگابایت'; },
    date(value) { return new Date(value).toLocaleString('fa-IR'); },
    fail(error) {
      const data = error.response && error.response.data;
      const messages = value => {
        if (typeof value === 'string') return [value];
        if (Array.isArray(value)) return value.flatMap(messages);
        if (value && typeof value === 'object') {
          if (value.messages) return messages(value.messages);
          if (value.detail) return messages(value.detail);
          return Object.values(value).flatMap(messages);
        }
        return [];
      };
      this.error = error.response && error.response.status === 413
        ? 'حجم فایل از محدودیت آپلود سرور بیشتر است؛ تنظیمات پراکسی سرور را بررسی کنید.'
        : error.response && error.response.status === 401
          ? 'نشست ورود معتبر نیست؛ دوباره وارد پنل شوید.'
          : (messages(data).filter(Boolean).join(' — ') || 'ارتباط با سرور برقرار نشد؛ دوباره تلاش کنید.');
    },
    load() {
      if (!this.canLoad) return;
      this.loading = true; this.error = '';
      this.request({ url: this.endpoint('api/v1/mobile/stock-app/releases'),
        success: data => { this.releases = data; this.loading = false; },
        error: error => { this.fail(error); this.loading = false; } });
    },
    upload() {
      if (!this.isManager || this.busy || !this.$refs.form.validate()) return;
      const body = new FormData();
      body.append('version_code', this.versionCode); body.append('version_name', this.versionName.trim());
      body.append('notes', this.notes || ''); body.append('required', this.required); body.append('apk', this.apk);
      this.uploading = true; this.error = ''; this.notice = '';
      this.request({ url: this.endpoint('api/v1/mobile/stock-app/releases'), method: 'post', data: body,
        success: () => { this.uploading = false; this.$refs.form.reset(); this.required = false;
          this.notice = 'پیش‌نویس ثبت شد. برای فعال‌شدن آپدیت، نسخه را منتشر کنید.'; this.load(); },
        error: error => { this.uploading = false; this.fail(error); } });
    },
    publish() {
      if (!this.isManager || this.busy || !this.confirmation) return;
      this.publishing = true; this.error = '';
      this.request({ url: this.endpoint('api/v1/mobile/stock-app/releases/' + this.confirmation.id + '/publish'),
        method: 'post', data: { action: this.confirmation.published ? 'withdraw' : 'publish' },
        success: () => { this.publishing = false; this.confirmation = null; this.notice = 'وضعیت انتشار ذخیره شد.'; this.load(); },
        error: error => { this.publishing = false; this.fail(error); } });
    },
  },
};
</script>

<style scoped>
.release-page { max-width: 1400px; }
.release-notes { white-space: pre-wrap; line-height: 1.9; }
</style>
